import { get, isObject, isString } from 'lodash';

import { Date } from '@shared/ui/components/Date';
import { DateTime } from '@shared/ui/components/DateTime';

import { ColumnConfiguration } from './DataTable.types';

type DataTableColumnContentProps<T> = {
  column: ColumnConfiguration<T>;
  row: T;
};

export function DataTableColumnContents<T>({ column, row }: DataTableColumnContentProps<T>) {
  if (isString(column.render)) {
    return get(row, column.render, null);
  }

  if (column.render) {
    return column.render(row) || null;
  }

  if (!column.name) {
    console.error('No column name specified');

    return null;
  }

  // @ts-expect-error
  if (!(column.name in row)) {
    console.error(`Column name [${column.name}] doesn't exist in data`);

    return null;
  }

  // @ts-expect-error
  const data = row[column.name];

  if (column.type === 'date') {
    if (isString(data)) {
      return <Date date={data} />;
    }
  }

  if (column.type === 'datetime') {
    if (isString(data)) {
      return <DateTime dateTime={data} />;
    }
  }

  if (Array.isArray(data) || isObject(data)) {
    console.error(`Column name [${column.name}] can not be rendered`);

    return null;
  }

  return data;
}
